<template>
  <div class="row justify-center" style="min-width: 800px;min-height: 95vh">
    <div class="card q-pa-md">

      <h4 class="mt-0 mb-3 text-left" style="font-size: 26px; font-weight: 300">
        Update Address
      </h4>
      <q-form ref="form">
        <div class="row q-col-gutter-sm">
          <!-- <div class="col-12">
                    <q-input :rules="[val => val && val.length > 0 || 'Please enter Email',
                    val => val.length && emailPattern.test(val) || 'Invalid Email']"
                        class="searchBox my-3" :style="'padding-bottom: 55px !important; font-size: larger;'" label="Email*" lazy-rules type="email" v-model="email"></q-input>
                </div> -->
          <div class="col-12">
            <q-input :rules="[val => val && val.length > 0 || 'Please enter address']" class="searchBox p-2 pt-0 my-3"
              label="Address Line 1*" lazy-rules v-model="form.address.add1"></q-input>
          </div>
          <div class="col-12">
            <q-input class="searchBox p-2 pt-0 my-3" label="Address Line 2" v-model="form.address.add2"></q-input>
          </div>
          <div class="col-6">
            <q-select :options="pinArr" @blur="onPopupHide" @filter="searchPincode" @input="autoFillAddressFromPin"
              class="searchBox p-2 pt-0 my-3" clearable fill-input label="Search by Pincode*" outlined use-input
              v-model="form.address.pin">
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:option="scope">
                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                  <q-item-section>
                    <q-item-label>
                      {{ scope.opt.Area }}, {{ scope.opt.PinCode }}, {{ scope.opt.DistrictName }},
                      {{ scope.opt.StateName }}
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:selected-item="scope">
                {{ scope.opt.PinCode }}
              </template>
            </q-select>
          </div>
          <div class="col-6">
            <q-input :rules="[val => val && val.length > 0 || 'Please enter Area']" class="searchBox p-2 pt-0 my-3"
              label="Area*" lazy-rules v-model="form.address.area"></q-input>
          </div>
          <div class="col-6">
            <q-input :rules="[val => val && val.length > 0 || 'Please enter City']" class="searchBox p-2 pt-0 my-3"
              label="City*" lazy-rules v-model="form.address.city"></q-input>
          </div>
          <div class="col-6">
            <q-input :rules="[val => val && val.length > 0 || 'Please enter State']" class="searchBox p-2 pt-0 my-3"
              label="State*" lazy-rules v-model="form.address.state"></q-input>
          </div>
          <div class="col-6">
            <q-input :rules="[val => val && val.length > 0 || 'Please enter Country']" class="searchBox p-2 pt-0 my-3"
              label="Country*" lazy-rules v-model="form.address.country"></q-input>
          </div>
          <div class="col-12 w-100">
            <div class="position-relative w-100" style="margin-left: -16px;">
              <div class="app-fixed-footer w-100" style="padding-left: 14px; bottom: 20px;">
                <div class="d-flex " style="justify-content: left">
                  <q-btn @click="updateAddress('form')" class="pd-btn  my-3">Update Address
                  </q-btn>
                  <q-btn @click="closeDialog" class=" my-3 ml-3" color="primary">CANCEL</q-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </q-form>
    </div>
  </div>
</template>
  
<script>
import axios from 'axios';
import Constants from '../../Constants/Constant';
import { SEARCH_PINCODE } from '../../graphql/queries/territories';

export default {
  apollo: {
    Territories: {
      query: SEARCH_PINCODE,
      fetchPolicy: 'network-only',
      skip: true,
      variables() {
        return {
          pinFilter: this.pinFilter ? this.pinFilter : '0',
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.pinArr = data.Territories
          this.temp_pinArr = JSON.parse(JSON.stringify(data.Territories))
        }
      },
    },
  },
  name: 'EditEmail',
  data: function () {
    return {
      email: '',
      pinArr: [],
      temp_pinArr: [],
      form: {
        address: {
          add1: '', add2: '', pin: '', area: '',
          city: '', state: '', country: '',
        },
      },
      userObj: JSON.parse(localStorage.getItem('user')),
      loggedIn_partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType,
      emailPattern: new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
    }
  },
  created() {
    this.email = this.userObj.email;
    this.fillOldAddress();
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    closeDialog() {
      this.$emit('closeUpdateAddressDialog', false)
    },

    fillOldAddress() {
      this.form.address.add1 = this.userObj.organization.address.add1,
        this.form.address.add2 = this.userObj.organization.address.add2,
        this.form.address.pin = this.userObj.organization.address.pin,
        this.form.address.area = this.userObj.organization.address.area,
        this.form.address.city = this.userObj.organization.address.city,
        this.form.address.state = this.userObj.organization.address.state,
        this.form.address.country = this.userObj.organization.address.country
    },

    autoFillAddressFromPin() {
      if (this.form.address.pin) {
        this.form.address.area = this.form.address.pin.Area
        this.form.address.city = this.form.address.pin.DistrictName
        this.form.address.state = this.form.address.pin.StateName
        this.form.address.country = this.form.address.pin.CountryName
        this.form.address.pin = this.form.address.pin.PinCode
      } else {
        this.form.address.pin = ''
        this.form.address.area = ''
        this.form.address.city = ''
        this.form.address.state = ''
        this.form.address.country = ''
      }
    },
    onPopupHide(val) {
      if (this.tempValue && this.tempValue.length == 6) {
        this.pinArr = [{ PinCode: this.tempValue }]
        this.form.address.pin = this.tempValue
      }
      this.tempValue = null
    },
    searchPincode(val, update, abort) {
      this.tempValue = val
      this.pinArr = JSON.parse(JSON.stringify(this.temp_pinArr))
      if (val.length < 5) {
        abort()
        return
      }
      update(() => {
        this.pinFilter = '%' + val + '%'
        this.$apollo.queries.Territories.skip = false
      })
    },

    async updateAddress(name) {
      this.$refs[name].validate().then(async (success) => {
        if (success) {
          const apiUrl = Constants.api_url + 'updateAddress';
          try {
            const request = {
              orgId: this.userObj.organization.id,
              pin: this.form.address.pin,
              add1: this.form.address.add1,
              add2: this.form.address.add2,
              area: this.form.address.area,
              city: this.form.address.city,
              state: this.form.address.state,
              country: this.form.address.country
            }

            const response = await axios.post(apiUrl, request);
            if (response && response.data) {
              const userDataString = localStorage.getItem('user');
              const userData = JSON.parse(userDataString);
              userData.organization.address = {
                pin: request.pin,
                add1: request.add1,
                add2: request.add2,
                area: request.area,
                city: request.city,
                state: request.state,
                country: request.country
              };
              const updatedUserDataString = JSON.stringify(userData);
              localStorage.setItem('user', updatedUserDataString);

              this.$q.notify({
                position: 'top-right',
                message: `Your Address updated successfully.`,
              });
              this.$emit('closeUpdateAddressDialog', false);
            }
          } catch (error) {
            console.error("Error in Update Address", error);
          }
        } else {
          this.$q.notify({
            position: 'top-right',
            message: `Please review the form errors highlighted in red.`,
          });
        }
      })
    }
  }
}
</script>
  
<style scoped>
.card {
  text-align: center;
  width: 100%;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: bottom;
  border-radius: 4px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
  position: relative;
}

.section-title {
  font-weight: bolder;
  font-size: 16px;
}

.bank-card {
  margin-top: 7px;
}

.card-close-icon {
  margin: -24px -17px 0 0;
}

/deep/ .q-field--outlined .q-field__control {
  padding: 0px !important;
}
</style>
  